import React from 'react'
import { useHistory, useLocation } from 'react-router'
import { Layout } from 'antd'
import 'antd/dist/antd.css'
import HeaderComponent from '../Header/HeaderComponent'
import DefaultSidebar from './DefaultSidebar'
import ProfilesSidebar from './ProfilesSidebar'
import DefaultSidebarV2 from './DefaultSidebarV2'
import EventSidebar from './EventSidebar'
import BackSideBar from './BackSidebar'
import LeagueSidebar from './LeagueSidebar'
import CommunitySidebar from './CommunitySidebar'
import ExternalSidebar from './ExternalSidebar'
import ClassesSidebar from './ClassesSidebar'
import './styles/sidebar.scss'
import NewSideBar from './NewSidebar'
import BreadCrumbs from 'components/global/BreadCrumbs'
import { myStore } from 'state/store'
import { capitalizeFirstLetter } from 'helper/utility'

const NavBar = ({ children, id }: any) => {
  const history = useHistory()
  const location = useLocation()
  const crumbs = myStore(store => store.crumbs)

  // const renderSwitch = (param: any) => {
  //   switch (param) {
  //     case `/organization-profile/${id}`:
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           <Layout className="default-layout">{children}</Layout>
  //         </Layout>
  //       )
  //     case `/organizer-profile/${id}`:
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           <Layout className="default-layout">{children}</Layout>
  //         </Layout>
  //       )
  //     case '/family-profile':
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           <Layout className="profile-layout">{children}</Layout>
  //         </Layout>
  //       )
  //     case `/family-profile/${id}`:
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           <Layout className="profile-layout">{children}</Layout>
  //         </Layout>
  //       )
  //     case `/parent-profile/${id}`:
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/sessiondetails`:
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/Jobs`:
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case '/kid-details':
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           <Layout className="profile-layout">{children}</Layout>
  //         </Layout>
  //       )
  //     case '/kid-profile':
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/kid-profile/${id}`:
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case '/coach-profile':
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/spaces/create-event`:
  //       return (
  //         <Layout className="event-layout">
  //           <EventSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/spaces/update-event/${id}`:
  //       return (
  //         <Layout className="event-layout">
  //           <EventSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/spaces/create-league`:
  //       return (
  //         <Layout className="event-layout">
  //           <LeagueSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/spaces/update-league/${id}`:
  //       return (
  //         <Layout className="event-layout">
  //           <LeagueSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/create-community`:
  //       return (
  //         <Layout className="event-layout">
  //           <CommunitySidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/update-community/${id}`:
  //       return (
  //         <Layout className="event-layout">
  //           <CommunitySidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case '/create-external':
  //       return (
  //         <Layout className="event-layout">
  //           <ExternalSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/update-external/${id}`:
  //       return (
  //         <Layout className="event-layout">
  //           <ExternalSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case '/events-details':
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case '/event-chats':
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )

  //     case '/proposed-mentors':
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case '/RequestDetails':
  //       return (
  //         <Layout>
  //           <BackSideBar link={'/RequestDetails'} />
  //           {children}
  //         </Layout>
  //       )
  //     case `/mentor-profile/${id}`:
  //       return (
  //         <Layout>
  //           <ProfilesSidebar />
  //           {children}
  //         </Layout>
  //       )
  //     case `/manage-listing/${id}`:
  //       return (
  //         <Layout>
  //           <BackSideBar link={'/settings'} />
  //           {children}
  //         </Layout>
  //       )
  //     default:
  //       return (
  //         <Layout>
  //           <DefaultSidebarV2 />
  //           <Layout>{children}</Layout>
  //         </Layout>
  //       )
  //   }
  // }

  const renderNav = param => {
    switch (param) {
      case `/spaces/create-event`:
        return <EventSidebar />
      case `/spaces/update-event/${id}`:
        return <EventSidebar />
      case `/spaces/create-classes`:
        return <ClassesSidebar />
      case `/spaces/update-classes/${id}`:
        return <ClassesSidebar />
      case `/spaces/create-league`:
        return <LeagueSidebar />
      case `/spaces/update-league/${id}`:
        return <LeagueSidebar />
      case `/create-community`:
        return <CommunitySidebar />
      case `/update-community/${id}`:
        return <CommunitySidebar />
      case '/create-external':
        return <ExternalSidebar />
      case `/update-external/${id}`:
        return <ExternalSidebar />
      default:
        return <NewSideBar />
    }
  }
  // return (
  //   <Layout>
  //     <HeaderComponent />
  //     {renderSwitch(history.location.pathname)}
  //   </Layout>
  // )

  const pathSnippets = location.pathname.split('/').filter(i => i)

  // Build breadcrumb items
  const breadcrumbItems = pathSnippets.map((segment, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}${
      location.search
    }`
    const isDynamic =
      /^[0-9a-fA-F]{24}$/.test(segment) || !isNaN(Number(segment))
    return {
      name: isDynamic
        ? capitalizeFirstLetter(crumbs)
        : capitalizeFirstLetter(pathSnippets[index]),
      link: url,
    }
  })

  const showCrumbs =
    location.pathname.includes('/spaces/') ||
    location.pathname.includes('spaces/league-detail/') ||
    location.pathname.includes('family/') ||
    location.pathname.includes('/mentors') ||
    location.pathname.includes('/organizer') ||
    location.pathname.includes('update-external/') ||
    location.pathname.includes('update-community/') ||
    location.pathname.includes('update-event/') ||
    location.pathname.includes('update-league/') ||
    location.pathname.includes('manage-listing/') ||
    location.pathname.includes('/settings/website-content-managment') ||
    location.pathname.includes('/settings/manage-communities')

  return (
    <Layout style={{ height: '100vh' }}>
      <HeaderComponent />
      <Layout style={{ backgroundColor: 'white' }}>
        {renderNav(history.location.pathname)}
        {/* <DefaultSidebarV2 /> */}
        <Layout className="default-layout">
          {breadcrumbItems.length > 1 && !showCrumbs && (
            <div className="mt-40px ml-35px ">
              <BreadCrumbs links={breadcrumbItems} />
            </div>
          )}
          {children}
        </Layout>
      </Layout>
    </Layout>
  )
}

export default NavBar
